import { type RefObject, useEffect } from "react";

// On browsers that support field-sizing, auto-resizing is handled by the CSS
// `field-sizing: content` property, so this hook becomes a no-op.
const supportsFieldSizing =
  typeof CSS !== "undefined" && CSS.supports("field-sizing", "content");

export default function useAutoResizeTextArea(
  textAreaRef: RefObject<HTMLTextAreaElement | null>,
  content: string,
) {
  useEffect(() => {
    if (!supportsFieldSizing && textAreaRef.current) {
      textAreaRef.current.style.overflowY = "hidden";
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      textAreaRef.current.style.overflow = "auto";
    }
  }, [textAreaRef, content]);
}
